"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-caption", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M5 24h26v2H5zM5 28h23v2H5z" }),
            _react2.default.createElement("path", { fill: "#BBB", d: "M1 19h34v1H1z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-caption.js
// module id = 1835
// module chunks = 0